import React from "react";
import { QRCodeSvg } from "./SVGComponent";
import placedHolder from "../../../assets/images/icons/placeholderLogo.png";
import { useTranslation } from "react-i18next";

const FrontCard = ({ data, color, logoSrc }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        width: 320,
        height: 204,
        borderRadius: 12,
        backgroundColor: color ? color : "#EEEEEE",
        boxShadow: color?"0 6px 24px rgba(0,0,0,0.22), 0 1px 4px rgba(0,0,0,0.12)":'unset',
        display: "flex",
        position: "relative",
        overflow: "hidden",
        transition: "background-color 0.25s ease",
      }}
    >
      {/* shimmer overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.08) 0%, transparent 60%)",
          pointerEvents: "none",
        }}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          padding: 14,
          gap: 10,
        }}
      >
      
        <div style={{ width: 75, height: 33.8, zIndex: 1, flexShrink: 0 }}>
          <div
            style={{
              width: 75,
              // height: 33.8,
              borderRadius: 5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            {logoSrc&& <img
              src={logoSrc}
              alt="logo"
              style={{
                maxWidth: "75px",
                // maxHeight: "33.8px",
                objectFit: "contain",
                // filter: "brightness(0) invert(1)",
              }}
            />}
          
          </div>
        </div>

       
        <div style={{ display: "flex", flexDirection: "column", zIndex: 1 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                fontSize: 12,
                fontWeight: 700,
                color: "#fff",
                textTransform: "uppercase",
                lineHeight: "18px",
              }}
            >
              {t(data.title1||"FRONT TITLE LINE 1")}
            </div>
            <div
              style={{
                fontSize: 12,
                fontWeight: 700,
                color: "#fff",
                textTransform: "uppercase",
                lineHeight: "18px",
              }}
            >
              {t(data.title2||"FRONT TITLE LINE 2")}
            </div>
            <div style={{ fontSize: 8, color: "#fff", lineHeight: "12px" }}>
              {t(data.subtitle||"Front Subtitle")}
            </div>
          </div>

       
          <div
            style={{ position: "absolute", bottom: 15, right: 15, zIndex: 1 }}
          >
            <QRCodeSvg />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrontCard;
